module.exports = {
  reminder: 'Free delivery available, 7 days a week',
}
  
